<script setup lang="ts">
import { getBoardBasisText } from '@apps/main/new-desktop/core/helpers/translation.helper';

import { AppMarkdownWrapper, AppLinkButton, AppTag } from '@libs/ui';
import { BoardBasisCode } from '@libs/trip-planner-interfaces';

import type { HotelRoom } from '../../models';

interface HotelStayRoomProps {
  room: HotelRoom;
}

const props = defineProps<HotelStayRoomProps>();

interface HotelStayRoomEmits {
  (eventName: 'more-information'): void;
}

const emit = defineEmits<HotelStayRoomEmits>();

function onMoreInformationClicked(): void {
  emit('more-information');
}
</script>

<template>
  <div class="hotel-stay-room">
    <div class="hotel-stay-header">
      <AppTag
        v-if="props.room.boardBasis !== BoardBasisCode.RO"
        size="s"
        type="purple"
      >
        <template #title>
          {{ getBoardBasisText(props.room.boardBasis) }}
        </template>
      </AppTag>
      <div class="hotel-stay-heading">
        {{ props.room.name }}
      </div>
      <div class="hotel-stay-paxes">
        {{ props.room.paxString }}
      </div>
      <AppMarkdownWrapper :source="props.room.description" />
    </div>
    <AppLinkButton
      size="s"
      :text="$t('planner.more_information')"
      @click="onMoreInformationClicked"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-stay-room {
  @include font-body-m-light;
  color: var(--color-neutral-70);

  .hotel-stay-header {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
    padding-bottom: var(--spacing-8);

    .hotel-stay-heading {
      color: var(--color-neutral-70);
      @include font-label-l-bold;
    }

    .hotel-stay-paxes {
      color: var(--color-neutral-70);
      @include font-label-s-light;
    }
  }
}
</style>
